import { DomainVerificationViewModel } from './DomainVerificationViewModel';

export class EmailDomainsViewModel{
  public static createEmpty(): EmailDomainsViewModel {
    return new EmailDomainsViewModel();
  }
  constructor(
    public Domains: DomainVerificationViewModel[] = [],
  ){}
}

